import { render, staticRenderFns } from "./rateCardTableView.vue?vue&type=template&id=ec506968&"
import script from "./rateCardTableView.vue?vue&type=script&lang=js&"
export * from "./rateCardTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports